import Layout from '@/layout'

// 系统管理路由
const systemRoutes = {
  path: '/system',
  component: Layout,
  redirect: '/system/role-management',
  name: 'System',
  meta: {
    title: '系统管理',
    icon: 'el-icon-setting',
    requiresAuth: true
  },
  children: [
    {
      path: 'role-management',
      component: () => import('@/views/system/role-management'),
      name: 'RoleManagement',
      meta: { title: '角色管理', requiresAuth: true }
    },
    {
      path: 'permission-management',
      component: () => import('@/views/system/permission-management'),
      name: 'PermissionManagement',
      meta: { title: '权限管理', requiresAuth: true }
    }
  ]
}

export default systemRoutes
